import { render, staticRenderFns } from "./BatteryPackData.vue?vue&type=template&id=65f1487b&"
import script from "./BatteryPackData.vue?vue&type=script&lang=js&"
export * from "./BatteryPackData.vue?vue&type=script&lang=js&"
import style0 from "./BatteryPackData.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports